<div class="circle">
    <div class="circle__item">
        <svg class="circle__spinner" viewBox="0 0 50 50">
            <circle class="path" cx="25" cy="25" r="20" fill="none" stroke="#93bfec" stroke-width="1"></circle>
        </svg>
    </div>
</div>